module.exports = __webpack_public_path__ + "static/media/restaurant-finder.ff90034e.png";